import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    GET_TASKS: undefined,
    API: {
      GET_TASKS: apiResourceActionCreator('tasks')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(`${API_ENDPOINT}/tasks`, authToken, actions.task.api.getTasks);

function* getTasks(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken));
}

const configuration = {
  name: 'getTasks',
  action: actions,
  sagas: getTasks,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      tasks: action.payload.tasks,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getTasks.js